import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import CircleCheck from 'dibs-icons/exports/legacy/CircleCheck.ts';

import styles from './NftSecondaryMarketToasts.scss';

export const NftSecondaryMarketAuctionCancelledToast: FC = () => {
    return (
        <div className={styles.toastWrapper}>
            <div className={styles.toastHeader}>
                <CircleCheck className={styles.icon} />

                <strong className={styles.toastHeaderText}>
                    <FormattedMessage
                        id="nft.secondaryMarket.toast.canceled.title"
                        defaultMessage="Auction Canceled"
                    />
                </strong>
            </div>

            <FormattedMessage
                id="nft.secondaryMarket.toast.loading.canceled.text"
                defaultMessage="Your auction was canceled successfully. This NFT has been moved back to your collection."
            />
        </div>
    );
};
